import { render, staticRenderFns } from "./RefferalDetails.vue?vue&type=template&id=54ec9d71&"
import script from "./RefferalDetails.vue?vue&type=script&lang=js&"
export * from "./RefferalDetails.vue?vue&type=script&lang=js&"
import style0 from "./RefferalDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports